import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Form, Button, Row, Col } from "react-bootstrap";
import FormContainer from "../components/FormContainer";
import { login, verifyEmailOTP ,resendOtp} from "../redux/actions/userActions";
import Loading from "../components/Loading";
import Message from "../components/Message";
import Meta from "../components/Meta";

const LoginScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [needOtpVerification, setNeedOtpVerification] = useState(false);
  const [emailForOtp, setEmailForOtp] = useState("");
  const [otp, setOtp] = useState("");
  const [resendCooldown, setResendCooldown] = useState(0);

  const userLogin = useSelector((state) => state.userLogin);
  const { loading, userInfo, error } = userLogin;

  const userVerifyOtp = useSelector((state) => state.userVerifyOtp);
  const {
    loading: loadingOtp,
    error: errorOtp,
    success: successOtp,
    userInfo: verifiedUser,
  } = userVerifyOtp;

  const redirect = location.search ? location.search.split("=")[1] : "";

  useEffect(() => {
  if (userInfo) {
    navigate(`/${redirect}`);
  }
  if (successOtp) {
    navigate(`/${redirect}`);
  }
  if (error && typeof error === "object" && error.message) {
    if (error.message.includes("Email not verified")) {
      setNeedOtpVerification(true);
      setEmailForOtp(error.email);
      setResendCooldown(error.resendAllowedIn || 0);
    }
  } else if (typeof error === "string") {
    // Handle string error as before
  }
}, [error, userInfo, successOtp, navigate, redirect]);

  // Countdown timer for resend OTP cooldown
  useEffect(() => {
    let timer;
    if (resendCooldown > 0) {
      timer = setInterval(() => {
        setResendCooldown((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [resendCooldown]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email !== "" && password !== "") dispatch(login(email, password));
  };

  const handleOtpSubmit = (e) => {
    e.preventDefault();
    if (otp.trim() === "") return;
    dispatch(verifyEmailOTP(emailForOtp, otp));
  };

  const handleResendOtp = () => {
  if (resendCooldown > 0) return;
  dispatch(resendOtp(emailForOtp));
  setResendCooldown(120);
};

const handleBackToLogin = () => {
  setNeedOtpVerification(false);
  setEmailForOtp("");
  setOtp("");
  // Optionally, reset any error state as well
};

  return (
    <>
      <Meta title="SYUKRA | Login" />
      <FormContainer>
        {!needOtpVerification ? (
          <>
            <h2>Sign In</h2>
            <Form onSubmit={handleSubmit}>
              {error && typeof error === "string" && (
                <Message variant="danger">{error}</Message>
              )}
              <Form.Group controlId="email" className="mt-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group controlId="password" className="mt-3">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Button className="mt-3" type="submit" variant="primary">
                {loading ? <Loading /> : `Sign In`}
              </Button>
            </Form>
            <Row className="py-3">
              <Col>
                New Customer? <Link to="/register">Register</Link>
              </Col>
            </Row>
          </>
        ) : (
          <>
            <h2>Verify Email</h2>
            <p>
              An OTP has been sent to <strong>{emailForOtp}</strong>. Please enter it below to verify your email.
            </p>
            {errorOtp && <Message variant="danger">{errorOtp}</Message>}
            <Form onSubmit={handleOtpSubmit}>
              <Form.Group controlId="otp" className="mt-3">
                <Form.Label>OTP</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Button
                className="mt-3"
                type="submit"
                variant="primary"
                disabled={loadingOtp || otp.trim() === ""}
              >
                {loadingOtp ? <Loading /> : "Verify"}
              </Button>
            </Form>
            <Button
              variant="link"
              onClick={handleResendOtp}
              disabled={resendCooldown > 0}
            >
              Resend OTP {resendCooldown > 0 ? `(${resendCooldown}s)` : ""}
            </Button>
              <Button variant="link" onClick={handleBackToLogin}>
                Back to Login
              </Button>

            <div className="mt-3">
              Don't have an account? <Link to="/register">Register here</Link>
            </div>
          </>

        )}
      </FormContainer>
    </>
  );
};

export default LoginScreen;
